import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, renderList as _renderList, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2993d8c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-sharing-editor" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "This profile belongs to this tree", -1))
const _hoisted_4 = {
  key: 0,
  class: "alert alert-primary alert-sm"
}
const _hoisted_5 = {
  key: 1,
  class: "help-text"
}
const _hoisted_6 = {
  key: 2,
  class: "alert alert-primary alert-sm"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help-text" }, " Sharing a profile with a group allows members of the group to see the profile in their family tree. ", -1))
const _hoisted_8 = { class: "list-unstyled shared-list" }
const _hoisted_9 = { class: "item-actions" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "actions" }

import { computed, ref } from 'vue'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { useDataGroupMemberStore } from '@/gp/DataGroupMemberStore'
import { useDataGroupInviteStore } from '@/gp/DataGroupInviteStore'
import { useUserStore } from '@/gp/UserStore'
import { usePersonStore } from '@/rd/PersonStore'
import { LoadMode } from '@/util/AsyncData'
import { ProfileUtils, ProfileType } from './ProfileUtils'
import { CompositeId } from '@/rd/CompositeId'
import { DataGroupInvite, DataGroupMember, DataGroupType, InvitationResult, ItemPermissions, PrincipalType } from '@/gp/GroupAdminModel'
import { PlusIcon } from '@zhuowenli/vue-feather-icons'
import FamilyGroupItem from '@/manage/familygroups/FamilyGroupItem.vue'
import ResearchGroupItem from '@/manage/researchgroups/ResearchGroupItem.vue'
import DataGroupShareModal from '@/manage/datagroups/DataGroupShareModal.vue'
import DataGroupInviteModal from '@/manage/datagroups/DataGroupInviteModal.vue'
import DataGroupMemberRemoveModal from '@/manage/datagroups/DataGroupMemberRemoveModal.vue'
import { PendingStatus } from '@/util/AppUtil'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileSharingEditor',
  props: {
    personId: {}
  },
  setup(__props: any) {

const props = __props;



const dataGroupShareModalRef = ref<InstanceType<typeof DataGroupShareModal>>()
const dataGroupInviteModalRef = ref<InstanceType<typeof DataGroupInviteModal>>()
const removeFamilyGroupModalRef = ref<InstanceType<typeof DataGroupMemberRemoveModal>>()

const dataGroupStore = useDataGroupStore()
const dataGroupMemberStore = useDataGroupMemberStore()
const dataGroupInviteStore = useDataGroupInviteStore()
const userStore = useUserStore()
const personStore = usePersonStore()

const permissionsRef = computed(() => dataGroupStore.getAsyncPermissions(profileGroupIdRef.value, LoadMode.EnsureLoaded)?.data ?? ItemPermissions.None)
const dataGroupRef = computed(() => dataGroupStore.getAsyncGroup(profileGroupIdRef.value, LoadMode.EnsureLoaded)?.data)
const familyGroupMembersRef = computed(() => dataGroupMemberStore.getMembersForDataGroups([profileGroupIdRef.value], LoadMode.EnsureLoaded)
  .filter(dm => dm.principalType == PrincipalType.FamilyGroup))
const isDataGroupAdminRef = computed(() => (permissionsRef.value & ItemPermissions.Administrator) == ItemPermissions.Administrator)
const dataGroupInvitesRef = computed(() => !isDataGroupAdminRef.value ? [] :
  dataGroupInviteStore.getInvitesForDataGroup(profileGroupIdRef.value, LoadMode.EnsureLoaded)
    .filter(inv => inv.result == InvitationResult.Pending))
const personRef = computed(() => personStore.getAsyncPerson(props.personId)?.data)

const profileGroupIdRef = computed(() => CompositeId.getGroupId(props.personId)!)
const canEditRef = computed(() => (permissionsRef.value & ItemPermissions.Modify) > 0)
const canEditSharingRef = computed(() => (permissionsRef.value & ItemPermissions.ModifyPermissions) > 0)
const ownerRef = computed(() => userStore.getAsyncUser(dataGroupRef.value?.ownerId)?.data) // loaded with group
const isResearchRef = computed(() => dataGroupRef.value?.groupType == DataGroupType.Research)
const profileTypeRef = computed(() => ProfileUtils.getProfileType(personRef.value, dataGroupRef.value, ownerRef.value))
const isSharedOrRequestedRef = computed(() => dataGroupInvitesRef.value.length || familyGroupMembersRef.value.length)

function onSelectDataGroupInvite(inv: DataGroupInvite) {
  dataGroupInviteModalRef.value?.openEdit(inv.id!)
}

function onRequestShare(familyGroupId: string) {
  dataGroupInviteModalRef.value?.openNew(profileGroupIdRef.value, familyGroupId)
}

function onShare() {
  const familyGroupIds = familyGroupMembersRef.value.map(m => m.principalId!)
  familyGroupIds.push(...dataGroupInvitesRef.value.map(inv => inv.principalId!))
  dataGroupShareModalRef.value?.open(profileGroupIdRef.value, familyGroupIds)
}

function onRemoveFamilyGroup(dm: DataGroupMember) {
  removeFamilyGroupModalRef.value?.open(dm)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isResearchRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(ResearchGroupItem, {
            "data-group-id": dataGroupRef.value?.id,
            "ensure-loaded": ""
          }, null, 8, ["data-group-id"])
        ]))
      : _createCommentVNode("", true),
    (profileTypeRef.value == _unref(ProfileType).Research)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (personRef.value?.restricted)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " This profile is restricted. It is only visible to the tree owner. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, " This profile is visible to anyone the tree is shared with. "))
        ], 64))
      : (!isSharedOrRequestedRef.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, " This profile is not shared with any groups. "))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _hoisted_7,
            _createElementVNode("ul", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataGroupInvitesRef.value, (inv) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: inv.id
                }, [
                  _createVNode(FamilyGroupItem, {
                    "family-group-id": inv.principalId,
                    "select-mode": "",
                    status: _unref(PendingStatus),
                    onClick: ($event: any) => (onSelectDataGroupInvite(inv))
                  }, null, 8, ["family-group-id", "status", "onClick"])
                ]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(familyGroupMembersRef.value, (dm) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: dm.id
                }, [
                  _createVNode(FamilyGroupItem, {
                    "family-group-id": dm.principalId
                  }, null, 8, ["family-group-id"]),
                  _createElementVNode("div", _hoisted_9, [
                    (canEditRef.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-inline btn-link",
                          onClick: ($event: any) => (onRemoveFamilyGroup(dm))
                        }, " Remove ", 8, _hoisted_10))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ], 64)),
    _createElementVNode("div", _hoisted_11, [
      (canEditSharingRef.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (isSharedOrRequestedRef.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-inline btn-link",
                  onClick: onShare
                }, " Share with another group "))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn btn-primary",
                  onClick: onShare
                }, [
                  _createVNode(_unref(PlusIcon), {
                    size: "1.2x",
                    class: "mb-1"
                  }),
                  _createTextVNode(" Share this profile ")
                ]))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(DataGroupShareModal, {
      ref_key: "dataGroupShareModalRef",
      ref: dataGroupShareModalRef,
      profile: "",
      onRequestShare: onRequestShare
    }, null, 512),
    _createVNode(DataGroupInviteModal, {
      ref_key: "dataGroupInviteModalRef",
      ref: dataGroupInviteModalRef
    }, null, 512),
    _createVNode(DataGroupMemberRemoveModal, {
      ref_key: "removeFamilyGroupModalRef",
      ref: removeFamilyGroupModalRef,
      profile: ""
    }, null, 512)
  ]))
}
}

})